export enum LoginStatusType {
  LOGGED = 'logged in',
  NOT_LOGGED = 'not Logged',
  FAILURE = 'failure',
}

interface LanguageItem {
  name: string;
  key: string;
  langClass: string;
}

export type ProfilePreferences = {
  autoPlayOnLoad?: boolean;
  preferredAudioLanguage?: LanguageItem;
  preferredTextLanguage?: LanguageItem;
};
